<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9234_68434)">
      <path
        d="M29.731 21.7675C30.091 21.4075 30.091 20.8075 29.731 20.4475L24.391 15.1075C21.941 12.6575 18.611 11.2875 15.151 11.3075C14.691 11.3075 14.241 11.1275 13.921 10.7975L11.341 8.22754L8.25098 11.3175L10.831 13.8975C11.161 14.2275 11.341 14.6675 11.341 15.1375C11.321 18.6075 12.681 21.9375 15.131 24.3875L20.471 29.7275C20.831 30.0875 21.421 30.0875 21.791 29.7275L29.731 21.7675Z"
        fill="url(#paint0_linear_9234_68434)"
      />
      <path
        d="M29.731 21.7675C30.091 21.4075 30.091 20.8075 29.731 20.4475L24.391 15.1075C21.941 12.6575 18.611 11.2875 15.151 11.3075C14.691 11.3075 14.241 11.1275 13.921 10.7975L11.341 8.22754L8.25098 11.3175L10.831 13.8975C11.161 14.2275 11.341 14.6675 11.341 15.1375C11.321 18.6075 12.681 21.9375 15.131 24.3875L20.471 29.7275C20.831 30.0875 21.421 30.0875 21.791 29.7275L29.731 21.7675Z"
        fill="url(#paint1_linear_9234_68434)"
      />
      <path
        d="M29.731 21.7675C30.091 21.4075 30.091 20.8075 29.731 20.4475L24.391 15.1075C21.941 12.6575 18.611 11.2875 15.151 11.3075C14.691 11.3075 14.241 11.1275 13.921 10.7975L11.341 8.22754L8.25098 11.3175L10.831 13.8975C11.161 14.2275 11.341 14.6675 11.341 15.1375C11.321 18.6075 12.681 21.9375 15.131 24.3875L20.471 29.7275C20.831 30.0875 21.421 30.0875 21.791 29.7275L29.731 21.7675Z"
        fill="url(#paint2_radial_9234_68434)"
      />
      <path
        d="M29.731 21.7675C30.091 21.4075 30.091 20.8075 29.731 20.4475L24.391 15.1075C21.941 12.6575 18.611 11.2875 15.151 11.3075C14.691 11.3075 14.241 11.1275 13.921 10.7975L11.341 8.22754L8.25098 11.3175L10.831 13.8975C11.161 14.2275 11.341 14.6675 11.341 15.1375C11.321 18.6075 12.681 21.9375 15.131 24.3875L20.471 29.7275C20.831 30.0875 21.421 30.0875 21.791 29.7275L29.731 21.7675Z"
        fill="url(#paint3_radial_9234_68434)"
      />
      <path
        d="M29.731 21.7675C30.091 21.4075 30.091 20.8075 29.731 20.4475L24.391 15.1075C21.941 12.6575 18.611 11.2875 15.151 11.3075C14.691 11.3075 14.241 11.1275 13.921 10.7975L11.341 8.22754L8.25098 11.3175L10.831 13.8975C11.161 14.2275 11.341 14.6675 11.341 15.1375C11.321 18.6075 12.681 21.9375 15.131 24.3875L20.471 29.7275C20.831 30.0875 21.421 30.0875 21.791 29.7275L29.731 21.7675Z"
        fill="url(#paint4_radial_9234_68434)"
      />
      <path
        d="M15.7406 11.3277C15.5506 11.3177 15.3506 11.3177 15.1506 11.3177C14.6906 11.3177 14.2406 11.1377 13.9206 10.8077L11.0006 7.8877L7.91064 10.9877L10.8206 13.9077C11.1506 14.2377 11.3306 14.6777 11.3306 15.1477C11.3306 15.3477 11.3306 15.5377 11.3406 15.7377L14.5106 15.2977C14.9206 15.2377 15.2406 14.9177 15.3006 14.5077L15.7406 11.3277Z"
        fill="url(#paint5_linear_9234_68434)"
      />
      <path
        d="M15.7406 11.3277C15.5506 11.3177 15.3506 11.3177 15.1506 11.3177C14.6906 11.3177 14.2406 11.1377 13.9206 10.8077L11.0006 7.8877L7.91064 10.9877L10.8206 13.9077C11.1506 14.2377 11.3306 14.6777 11.3306 15.1477C11.3306 15.3477 11.3306 15.5377 11.3406 15.7377L14.5106 15.2977C14.9206 15.2377 15.2406 14.9177 15.3006 14.5077L15.7406 11.3277Z"
        fill="url(#paint6_linear_9234_68434)"
      />
      <path
        d="M15.7406 11.3277C15.5506 11.3177 15.3506 11.3177 15.1506 11.3177C14.6906 11.3177 14.2406 11.1377 13.9206 10.8077L11.0006 7.8877L7.91064 10.9877L10.8206 13.9077C11.1506 14.2377 11.3306 14.6777 11.3306 15.1477C11.3306 15.3477 11.3306 15.5377 11.3406 15.7377L14.5106 15.2977C14.9206 15.2377 15.2406 14.9177 15.3006 14.5077L15.7406 11.3277Z"
        fill="url(#paint7_radial_9234_68434)"
      />
      <path
        d="M7.89066 5.9277L5.96066 7.8577C5.85066 7.9677 5.68066 7.9677 5.57066 7.8577L3.68066 5.9577L6.00066 3.6377L7.89066 5.5377C8.00066 5.6477 8.00066 5.8177 7.89066 5.9277Z"
        fill="url(#paint8_linear_9234_68434)"
      />
      <path
        d="M7.89066 5.9277L5.96066 7.8577C5.85066 7.9677 5.68066 7.9677 5.57066 7.8577L3.68066 5.9577L6.00066 3.6377L7.89066 5.5377C8.00066 5.6477 8.00066 5.8177 7.89066 5.9277Z"
        fill="url(#paint9_linear_9234_68434)"
      />
      <path
        d="M7.89066 5.9277L5.96066 7.8577C5.85066 7.9677 5.68066 7.9677 5.57066 7.8577L3.68066 5.9577L6.00066 3.6377L7.89066 5.5377C8.00066 5.6477 8.00066 5.8177 7.89066 5.9277Z"
        fill="url(#paint10_radial_9234_68434)"
      />
      <path
        d="M6.8903 3.60756L3.6003 6.89756C3.4403 7.05756 3.1903 7.06756 3.0303 6.90756L2.1103 5.98756C1.9603 5.83756 1.9603 5.57756 2.1203 5.41756L5.4003 2.12756C5.5603 1.96756 5.8103 1.95756 5.9703 2.11756L6.9003 3.04756C7.0503 3.19756 7.0503 3.44756 6.8903 3.60756Z"
        fill="url(#paint11_linear_9234_68434)"
      />
      <path
        d="M6.8903 3.60756L3.6003 6.89756C3.4403 7.05756 3.1903 7.06756 3.0303 6.90756L2.1103 5.98756C1.9603 5.83756 1.9603 5.57756 2.1203 5.41756L5.4003 2.12756C5.5603 1.96756 5.8103 1.95756 5.9703 2.11756L6.9003 3.04756C7.0503 3.19756 7.0503 3.44756 6.8903 3.60756Z"
        fill="url(#paint12_linear_9234_68434)"
      />
      <path
        d="M12.0006 5.68766C12.3706 5.68766 12.6706 5.38769 12.6706 5.01766C12.6706 4.64763 12.3706 4.34766 12.0006 4.34766C11.6305 4.34766 11.3306 4.64763 11.3306 5.01766C11.3306 5.38769 11.6305 5.68766 12.0006 5.68766Z"
        fill="url(#paint13_radial_9234_68434)"
      />
      <path
        d="M5.00098 13.0078C5.55326 13.0078 6.00098 12.5601 6.00098 12.0078C6.00098 11.4555 5.55326 11.0078 5.00098 11.0078C4.44869 11.0078 4.00098 11.4555 4.00098 12.0078C4.00098 12.5601 4.44869 13.0078 5.00098 13.0078Z"
        fill="url(#paint14_radial_9234_68434)"
      />
      <path
        d="M5.00098 13.0078C5.55326 13.0078 6.00098 12.5601 6.00098 12.0078C6.00098 11.4555 5.55326 11.0078 5.00098 11.0078C4.44869 11.0078 4.00098 11.4555 4.00098 12.0078C4.00098 12.5601 4.44869 13.0078 5.00098 13.0078Z"
        fill="url(#paint15_radial_9234_68434)"
      />
      <path
        d="M26.7304 21.0277L20.9904 26.7777C20.8704 26.8977 20.6704 26.8977 20.5504 26.7777L17.2404 23.4577C17.1204 23.3377 17.1204 23.1377 17.2404 23.0177L22.9804 17.2677C23.1004 17.1477 23.3004 17.1477 23.4204 17.2677L26.7304 20.5877C26.8504 20.7077 26.8504 20.9077 26.7304 21.0277Z"
        fill="url(#paint16_linear_9234_68434)"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="#E9D2C1"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="url(#paint17_linear_9234_68434)"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="url(#paint18_linear_9234_68434)"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="url(#paint19_radial_9234_68434)"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="url(#paint20_radial_9234_68434)"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="url(#paint21_radial_9234_68434)"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="url(#paint22_radial_9234_68434)"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="url(#paint23_radial_9234_68434)"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="url(#paint24_radial_9234_68434)"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="url(#paint25_radial_9234_68434)"
      />
      <path
        d="M9.47031 2.00756C9.20031 2.02756 9.00031 2.25756 9.00031 2.52756V5.18756C9.00031 5.43756 8.68031 5.52756 8.54031 5.32756L7.81031 4.20756C7.57031 3.84756 7.00031 4.01756 7.00031 4.44756V6.34756C7.00031 6.71756 6.71031 7.00756 6.35031 7.00756H5.06031C4.67031 7.00756 4.48031 7.47756 4.75031 7.75756L5.57031 8.58756C5.73031 8.73756 5.62031 9.00756 5.40031 9.00756H2.52031C2.25031 9.00756 2.02031 9.20756 2.00031 9.47756C1.99031 9.76756 2.22031 10.0076 2.50031 10.0076H7.28031L8.63031 8.65756L10.0003 7.28756V2.50756C10.0003 2.21756 9.76031 1.98756 9.47031 2.00756Z"
        fill="url(#paint26_radial_9234_68434)"
      />
      <path
        d="M10.0703 7.21774L7.20033 10.0977C6.90033 10.3977 6.91033 10.8977 7.22033 11.2077C7.53033 11.5177 8.03033 11.5377 8.33033 11.2277L11.2003 8.35774C11.5003 8.05774 11.4903 7.55774 11.1803 7.24774C10.8603 6.92774 10.3703 6.91774 10.0703 7.21774Z"
        fill="url(#paint27_linear_9234_68434)"
      />
      <path
        d="M10.0703 7.21774L7.20033 10.0977C6.90033 10.3977 6.91033 10.8977 7.22033 11.2077C7.53033 11.5177 8.03033 11.5377 8.33033 11.2277L11.2003 8.35774C11.5003 8.05774 11.4903 7.55774 11.1803 7.24774C10.8603 6.92774 10.3703 6.91774 10.0703 7.21774Z"
        fill="url(#paint28_radial_9234_68434)"
      />
      <path
        d="M10.0703 7.21774L7.20033 10.0977C6.90033 10.3977 6.91033 10.8977 7.22033 11.2077C7.53033 11.5177 8.03033 11.5377 8.33033 11.2277L11.2003 8.35774C11.5003 8.05774 11.4903 7.55774 11.1803 7.24774C10.8603 6.92774 10.3703 6.91774 10.0703 7.21774Z"
        fill="url(#paint29_radial_9234_68434)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_9234_68434"
        x1="25.9378"
        y1="16.625"
        x2="16.7503"
        y2="25.875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#76B957" />
        <stop
          offset="0.163055"
          stop-color="#66AF3A"
        />
        <stop
          offset="0.498449"
          stop-color="#5B9636"
        />
        <stop
          offset="0.823938"
          stop-color="#567D3D"
        />
        <stop
          offset="1"
          stop-color="#6F7C6F"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_9234_68434"
        x1="26.0003"
        y1="25.5312"
        x2="25.3128"
        y2="24.8437"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.386364"
          stop-color="#587D41"
        />
        <stop
          offset="1"
          stop-color="#609041"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint2_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21.7503 30.8125) rotate(-49.1276) scale(4.29798 1.39934)"
      >
        <stop stop-color="#6A7866" />
        <stop
          offset="1"
          stop-color="#609143"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint3_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(26.1878 20.6875) rotate(135) scale(4.33103 12.6026)"
      >
        <stop stop-color="#7AB95A" />
        <stop
          offset="1"
          stop-color="#7EB960"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint4_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.0941 22.25) rotate(135) scale(3.88909 0.309359)"
      >
        <stop stop-color="#86BD68" />
        <stop
          offset="1"
          stop-color="#8DC96F"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint5_linear_9234_68434"
        x1="9.5625"
        y1="12.8751"
        x2="12.9063"
        y2="9.53137"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.07922"
          stop-color="#C98975"
        />
        <stop
          offset="0.360475"
          stop-color="#D89E70"
        />
        <stop
          offset="0.693814"
          stop-color="#FFD38E"
        />
        <stop
          offset="0.891735"
          stop-color="#FFDE8F"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_9234_68434"
        x1="14.875"
        y1="15.1876"
        x2="11.625"
        y2="12.0939"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CDA164" />
        <stop
          offset="0.530716"
          stop-color="#C89D5E"
        />
        <stop
          offset="0.803656"
          stop-color="#C89D5E"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint7_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.6875 15.9689) rotate(60.7374) scale(2.32838 2.96208)"
      >
        <stop stop-color="#B3875F" />
        <stop
          offset="1"
          stop-color="#B68860"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint8_linear_9234_68434"
        x1="4.78127"
        y1="7.28137"
        x2="7.28127"
        y2="4.78137"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.00558659"
          stop-color="#B4855E"
        />
        <stop
          offset="0.375"
          stop-color="#CB9666"
        />
        <stop
          offset="0.6875"
          stop-color="#E9B87F"
        />
        <stop
          offset="1"
          stop-color="#E1B06C"
        />
      </linearGradient>
      <linearGradient
        id="paint9_linear_9234_68434"
        x1="5.00002"
        y1="4.81262"
        x2="6.65627"
        y2="6.18762"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.169492"
          stop-color="#AE7151"
        />
        <stop
          offset="0.313559"
          stop-color="#B27251"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint10_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.31252 5.70325) rotate(67.8759) scale(1.75416 0.720984)"
      >
        <stop
          offset="0.475585"
          stop-color="#A97133"
        />
        <stop
          offset="1"
          stop-color="#AD7436"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint11_linear_9234_68434"
        x1="1.49484"
        y1="5.12017"
        x2="5.18474"
        y2="1.12428"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.00558659"
          stop-color="#BE8766"
        />
        <stop
          offset="0.251689"
          stop-color="#D09568"
        />
        <stop
          offset="0.49526"
          stop-color="#E6B579"
        />
        <stop
          offset="0.730711"
          stop-color="#FFDD92"
        />
        <stop
          offset="0.896943"
          stop-color="#FFE090"
        />
        <stop
          offset="0.969861"
          stop-color="#ECD399"
        />
      </linearGradient>
      <linearGradient
        id="paint12_linear_9234_68434"
        x1="4.12748"
        y1="3.37218"
        x2="4.81498"
        y2="4.05968"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B1965E" />
        <stop
          offset="0.412559"
          stop-color="#AF935D"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint13_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.2968 4.76575) rotate(128.797) scale(1.02245)"
      >
        <stop stop-color="#FFF2D7" />
        <stop
          offset="0.875292"
          stop-color="#D3BBA1"
        />
      </radialGradient>
      <radialGradient
        id="paint14_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.44312 11.6318) rotate(128.797) scale(1.52605)"
      >
        <stop stop-color="#F3DBC9" />
        <stop
          offset="0.875292"
          stop-color="#CDB49C"
        />
      </radialGradient>
      <radialGradient
        id="paint15_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.00098 13.1721) rotate(90) scale(1.09375 2.62403)"
      >
        <stop stop-color="#DBADC9" />
        <stop
          offset="1"
          stop-color="#DDB0CA"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint16_linear_9234_68434"
        x1="25.9645"
        y1="19.9649"
        x2="19.8951"
        y2="26.0204"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFDE96" />
        <stop
          offset="0.546392"
          stop-color="#E8AC7B"
        />
        <stop
          offset="1"
          stop-color="#DA8971"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_9234_68434"
        x1="3.62467"
        y1="10.0076"
        x2="3.62467"
        y2="9.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D2A9BE" />
        <stop
          offset="1"
          stop-color="#DFBBBF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint18_linear_9234_68434"
        x1="10.0003"
        y1="5.40625"
        x2="9.21842"
        y2="5.40625"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.380508"
          stop-color="#FFEED4"
        />
        <stop
          offset="1"
          stop-color="#FBE4CD"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint19_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.71842 9.78125) rotate(-135) scale(2.49697 4.76437)"
      >
        <stop stop-color="#AEA182" />
        <stop
          offset="0.389381"
          stop-color="#C2B399"
        />
        <stop
          offset="1"
          stop-color="#AEA182"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint20_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.93717 3.46875) rotate(90) scale(2.42188 0.734375)"
      >
        <stop stop-color="#AEA182" />
        <stop
          offset="0.763514"
          stop-color="#C2B399"
        />
        <stop
          offset="1"
          stop-color="#AEA182"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint21_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3.3278 8.39063) rotate(0.271529) scale(3.29691 1.56169)"
      >
        <stop stop-color="#AEA182" />
        <stop
          offset="0.672566"
          stop-color="#C2B399"
        />
        <stop
          offset="1"
          stop-color="#AEA182"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint22_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.0778 4.73437) rotate(55.8641) scale(1.11377 0.485753)"
      >
        <stop
          offset="0.679001"
          stop-color="#FCE7CD"
        />
        <stop
          offset="1"
          stop-color="#FDE8CF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint23_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.58553 2.64844) rotate(91.2224) scale(5.48562 0.592663)"
      >
        <stop
          offset="0.238386"
          stop-color="#FCE7CD"
        />
        <stop
          offset="1"
          stop-color="#FDE8CF"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint24_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.93726 5.5) rotate(61.3268) scale(2.27954 0.546215)"
      >
        <stop
          offset="0.238386"
          stop-color="#E9D2C1"
        />
        <stop
          offset="1"
          stop-color="#E9D2C1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint25_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(5.81226 7.14063) rotate(65.8606) scale(2.31151 1.14629)"
      >
        <stop
          offset="0.149498"
          stop-color="#E9D2C1"
        />
        <stop
          offset="1"
          stop-color="#E9D2C1"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint26_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2.60913 9.48438) rotate(-1.53892) scale(5.23626 0.565722)"
      >
        <stop
          offset="0.238386"
          stop-color="#DFBFC0"
        />
        <stop
          offset="1"
          stop-color="#DFBFC0"
          stop-opacity="0"
        />
      </radialGradient>
      <linearGradient
        id="paint27_linear_9234_68434"
        x1="11.1935"
        y1="7.88159"
        x2="7.47276"
        y2="11.2843"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6EA34F" />
        <stop
          offset="0.481598"
          stop-color="#538728"
        />
        <stop
          offset="1"
          stop-color="#577F3C"
        />
      </linearGradient>
      <radialGradient
        id="paint28_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(10.5622 7.93774) rotate(135) scale(2.34229 0.464038)"
      >
        <stop stop-color="#85B569" />
        <stop
          offset="1"
          stop-color="#86B669"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint29_radial_9234_68434"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.37469 11.6252) rotate(-45) scale(2.20971 0.567202)"
      >
        <stop stop-color="#868A93" />
        <stop
          offset="1"
          stop-color="#7A7B86"
          stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_9234_68434">
        <rect
          width="32"
          height="32"
          fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
